//Positions
export const GetPositions = () => {
  return $.get('Position/GetPositions')
}
export const GetRoles = () => {
  return $.get('Position/GetRoles')
}
export const AddPosition = (positionModel) => {
  return $.post('Position/AddPosition',positionModel)
}
export const updateRole = (positionModel) => {
  return $.post('Position/UpdatePosition',positionModel)
}
export const DeletePosition = (positionid) => {
 return $.post('Position/DeletePosition?positionId='+positionid)
}
//END Positions

//ARE ANY OF THE FUNCTIONS BELOW USED... SEEMS THEY EXIST ELSEWHERE AS THOUGH THESE ARE OLD BUT WERE NOT REMOVED
export const GetLocations = () => {
  return $.get('Location/GetLocations')
}
export const GetPoolsById = (locationId) => {
  return $.get('Pool/GetPools?locationId='+locationId)
}
export const AddLocation = (locationModel) => {
  return $.post('Location/AddLocation',locationModel)
}
export const UpdateLocation = (locationModel) => {
  return $.post('Location/UpdateLocation',locationModel)
}
export const AddPool = (poolModel) => {
  return $.post('Pool/AddPool',poolModel)
}
export const UpdatePool = (poolModel) => {
  return $.post('Pool/UpdatePool',poolModel)
}
export const DeletePool = (poolid) => {
  return $.post('Pool/DeletePool?poolId='+poolid)
}
export const DeleteLocation = (locationid) => {
  return $.post('Location/DeleteLocation?locationid='+locationid)
}
export const UpdateOrganization = (organizationModel) => {
  return $.post('Account/UpdateOrganization',organizationModel)
}
//certifications
export const GetCertificationTypes = () => {
    return $.get('Personnel/GetCertificationTypes?activestatus='+'')
}
export const GetStates = () => {
  return $.get('Location/GetStates')
}
export const AddCertificationType = (CertificationType) => {
  return $.post('Personnel/AddCertificationType',CertificationType)
}
export const DeleteCertificationType = (id) => {
  return $.post('Personnel/DeleteCertificationType?CertificationTypeId='+id)
}
export const UpdateCertificationType = (model) => {
  return $.post('Personnel/UpdateCertificationType',model)
}
//ARE ANY OF THE FUNCTIONS ABOVE USED... SEEMS THEY EXIST ELSEWHERE AS THOUGH THESE ARE OLD BUT WERE NOT REMOVED


// WEBPACK FOOTER //
// ./src/pages/Administration/OrganizationDetails.service.js